export default __webpack_public_path__ + "static/live-like-a-local-61665fb80de7105db370470ceeb84ae7.jpg";